<div class="card-top-image" *ngIf="sectionInfo && sectionInfo.cardId=='A'">
    <div class="card-image">
    <img [src]="sectionInfo.imageUrl" alt="" class="article-image">
    </div>
    <div class="card-footer card-big-footer">
        <h2 class="webapp-title-secondary">{{sectionInfo.title}}</h2>
        <p>{{sectionInfo.text}}</p>

        <button class="button button-fill button-round color-dark" *ngIf="sectionInfo.moreDetailsActive">
            {{sectionInfo.moreDetailsButton}}
            <i class="fa-solid fa-arrow-right"></i>
        </button>

        <p *ngIf="sectionInfo.premiumText">{{sectionInfo.premiumText}}</p>
        <button *ngIf="sectionInfo.premiumButton" class="button button-round btn-premium" (click)="callToActionButton()">
            <i class="fa-solid fa-crown"></i> 
            {{sectionInfo.premiumButton}}
        </button><!--   -->
    </div>
</div>

<div class="card-top-image" *ngIf="sectionInfo && sectionInfo.cardId=='B'"><!-- *ngIf="userHasInssurance" -->
    <div class="card-image">
        <img [src]="sectionInfo.imageUrl" alt="" class="card-big-footer-image">
    </div>
    <div class="card-footer card-big-footer">
        <h2 class="webapp-title-secondary">{{sectionInfo.title}}</h2>
        <h5 class="webapp-pre-title">{{sectionInfo.subtitle}}</h5>
        <p>{{sectionInfo.description}}</p>
        <app-smart-paragraph [text]="sectionInfo.longPar" [limit]="sectionInfo.longParLimit"></app-smart-paragraph>
        <div class="info-block rounded">
            <div class="info-block-icon"><i class="fas fa-info-circle"></i></div>
            <p>{{sectionInfo.info}}</p>
            </div>
    </div>
</div>